import { createSlice } from '@reduxjs/toolkit';
const merchantAccount: any = {};
const merchantTransaction: any = {};
const filters: any = {};

export const initialState = {
	isLoading: false,
	merchantAccount,
	merchantAccounts: [],
	merchantTransactions: [],
	merchantTransaction,
	filters,
};
const merchantManagementSlice = createSlice({
	name: 'merchantManagement',
	initialState,
	reducers: {
		setMerchantsIsLoading: (state) => {
			state.isLoading = true;
		},
		resetMerchantsIsLoading: (state) => {
			state.isLoading = false;
		},
		setMerchantAccount: (state, action) => {
			state.merchantAccount = action.payload;
		},
		resetMerchantAccount: (state) => {
			state.merchantAccount = {};
		},
		setMerchantAccounts: (state, action) => {
			state.merchantAccounts = action.payload;
		},
		resetMerchantAccounts: (state) => {
			state.merchantAccounts = [];
		},
		setMerchantAccountFilters: (state, action) => {
			state.filters = action.payload;
		},
		resetMerchantAccountFilters: (state) => {
			state.filters = {};
		},
		setMerchantAccountTransactions: (state, action) => {
			state.merchantTransactions = action.payload;
		},
		resetMerchantAccountTransactions: (state) => {
			state.merchantTransactions = [];
		},
		setMerchantAccountTransaction: (state, action) => {
			state.merchantTransaction = action.payload;
		},
		resetMerchantAccountTransaction: (state) => {
			state.merchantTransaction = {};
		},
	},
});

export const {
	setMerchantsIsLoading,
	resetMerchantsIsLoading,
	setMerchantAccount,
	resetMerchantAccount,
	setMerchantAccounts,
	resetMerchantAccounts,
	setMerchantAccountFilters,
	resetMerchantAccountFilters,
	setMerchantAccountTransactions,
	resetMerchantAccountTransactions,
	setMerchantAccountTransaction,
	resetMerchantAccountTransaction,
} = merchantManagementSlice.actions;

export default merchantManagementSlice.reducer;
